import { Video } from "@/common/types/video";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { TabList } from "@/components/molecules/TabList";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { TabContent } from "@/components/organisms/TabContent";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { exerciseStart } from "@/common/functions/flutter";
import { useRecoilValue } from "recoil";
import { ExercisePartList } from "@/components/molecules/ExercisePartList";
import { studentUserState } from "@/common/states/user";
import { exercisePartCategory } from "@/data/category";
import { useNavigate, useParams } from "react-router";
import {
  GET_EXERCISE_AVAILABILITY,
  GET_VIDEOS_BY_CATEGORY,
} from "@/common/querykeys";
import { ExercisePointEligibility } from "@/common/types/student";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

const fetchVideosByCategory = async (category: string): Promise<Video[]> => {
  return await request<Video[]>({
    method: "GET",
    url: `/video-content/category/${category}`,
  });
};

export const ExerciseByPartPage = () => {
  const navigate = useNavigate();
  const student = useRecoilValue(studentUserState);
  const { exercisePartCategory: categoryParam } = useParams<{
    exercisePartCategory: string;
  }>();
  const [selectedVideoId, setSelectedVideoId] = useState<string | null>(null);
  const [exerciseModalShow, setExerciseModalShow] = useState(false);
  const category = categoryParam || exercisePartCategory[0]?.id;

  const { data: videos, isPending } = useQuery({
    queryKey: [GET_VIDEOS_BY_CATEGORY, category],
    queryFn: () => fetchVideosByCategory(category),
    initialData: [],
  });

  // 학생이 운동할 때 포인트 지급 가능 여부 조회 (🧑‍🎓)
  const { data: exercisePointEligibility } = useQuery<ExercisePointEligibility>(
    {
      queryKey: [GET_EXERCISE_AVAILABILITY],
      queryFn: async () => {
        const res = await request<ExercisePointEligibility[]>({
          method: "GET",
          url: `/student/video-point-eligibility/${student.id}`,
        });

        return res[0];
      },
    }
  );

  const handleTabChange = (tabId: string) => {
    navigate(`/exercise/partby/${tabId}`);
  };

  const handleExerciseStart = (videoId: string) => {
    exerciseStart(student?.id, videoId);
  };

  return (
    <>
      <MainTemplate
        nav={false}
        subPage={false}
        menuBtn={false}
        pageTitle="부위별 운동"
        buttonLeft={
          <Buttons
            type="button"
            size="headerTextIcon"
            layout="text"
            color="bright100"
            icon={<IconArrow />}
            label="운동"
            onClick={() => navigate("/exercise")}
          />
        }
      >
        <TabContent
          nav={false}
          tabList={
            <TabList
              data={exercisePartCategory}
              activeTab={category}
              onTabChange={handleTabChange}
            />
          }
        >
          <ExercisePartList
            videos={videos}
            isLoading={isPending}
            onClick={(videoId: string) => {
              // if (exercisePointEligibility?.points === 50000) {
              //   setExerciseModalShow(true);
              //   setSelectedVideoId(videoId);
              // } else {
              //   handleExerciseStart(videoId);
              // }
              handleExerciseStart(videoId);
            }}
          />
        </TabContent>
      </MainTemplate>
      {/* {exerciseModalShow &&
        exercisePointEligibility &&
        exercisePointEligibility?.points === 50000 && (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={(result: boolean) => {
              if (result && selectedVideoId) {
                handleExerciseStart(selectedVideoId);
              }
              setSelectedVideoId(null);
            }}
            type="point"
          />
        )} */}
    </>
  );
};
